interface Tag {
  value: string;
  isValid: boolean;
  isDuplicate?: boolean;
}

export const findDuplicateEmails = (tags: Tag[]) => {
  let containsDuplicates: { [key: string]: number } = {};
  let counter = 0;

  const newTagsWithDuplicate = tags.map((tag) => {
    if (containsDuplicates[tag.value]) {
      counter++;
      return { ...tag, isDuplicate: true };
    } else {
      containsDuplicates[tag.value] = 1;
    }
    return tag;
  });

  return { newTagsWithDuplicate, counter };
};
